import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchPhoneNumberPriceHistories } from "../../actions/callrecorder/phoneNumberPriceHistoriesActions";

export interface PhoneNumberPriceHistoryInterface {
  id: number;
  phone_number_price_id: number;
  csv_import_id: number | null;

  previous_currency: string;
  previous_monthly_fee: string;
  previous_setup_fee: string;

  new_currency: string;
  new_monthly_fee: string;
  new_setup_fee: string;

  previous_raw_monthly_fee: string | null;
  new_raw_monthly_fee: string | null;

  previous_raw_inbound_trunking_price: string | null;
  new_raw_inbound_trunking_price: string | null;

  previous_raw_inbound_trunking_from_landline: string | null;
  new_raw_inbound_trunking_from_landline: string | null;

  previous_raw_inbound_trunking_from_mobile: string | null;
  new_raw_inbound_trunking_from_mobile: string | null;

  previous_raw_inbound_sms_price: string | null;
  new_raw_inbound_sms_price: string | null;

  previous_raw_inbound_mms_price: string | null;
  new_raw_inbound_mms_price: string | null;

  previous_inbound_cost_per_min: string | null;
  new_inbound_cost_per_min: string | null;

  previous_inbound_sms_price: string | null;
  new_inbound_sms_price: string | null;

  previous_inbound_mms_price: string | null;
  new_inbound_mms_price: string | null;

  source: string;
  changed_at: string;
  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<PhoneNumberPriceHistoryInterface>();

const slice = createSlice({
  name: 'phoneNumberPriceHistories',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhoneNumberPriceHistories.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPhoneNumberPriceHistories.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.phoneNumberPriceHistories;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchPhoneNumberPriceHistories.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectPhoneNumberPriceHistoryById,
  selectIds: selectPhoneNumberPriceHistoryIds,
  selectEntities: selectPhoneNumberPriceHistoryEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.phoneNumberPriceHistories);
